/**
* Book Now CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book Now CTA component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'book-now-cta',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const sections = document.querySelectorAll( '[data-component="book-now-cta"]' );

      sections.forEach( ( section ) => {
        const mobileGroup = section.querySelector( '.relative.block.h-full' );
        const desktopGroup = section.querySelector( '.lg\\:block.hidden' );

        const animateGroup = ( group ) => {
          if ( !group ) return;

          const spaRocks = group.querySelector( '.book-now-cta__spa-rocks' );
          const rock = group.querySelector( '.book-now-cta__rock' );

          const images = [rock, spaRocks].filter( Boolean );
          if ( !images.length ) return;

          images.forEach( ( el ) => {
            gsap.set( el, {opacity: 0, yPercent: 100} );
          } );

          ScrollTrigger.create( {
            trigger: section,
            start: 'top 50%',
            once: true,
            onEnter: () => {
              gsap.to( images, {
                opacity: 1,
                yPercent: 0,
                ease: 'power2.out',
                duration: 0.75,
                stagger: 0.15,
              } );
            },
          } );
        };

        animateGroup( mobileGroup );
        animateGroup( desktopGroup );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'book-now-cta', COMPONENT );
} )( app );
